import { lazy } from "react";

const SystemSupportTicketsPage = lazy(
  () => import("@/widgets/system-admin/support-tickets/SupportTicketsPage"),
);
const SystemSupportTicketDetailPage = lazy(
  () => import("@/widgets/system-admin/support-tickets/SupportTicketDetailPage"),
);

const SystemSupportTicketsRoutes = {
  path: "support-tickets",
  children: [
    { index: true, element: <SystemSupportTicketsPage /> },
    { path: ":ticketId", element: <SystemSupportTicketDetailPage /> },
  ],
};

export default SystemSupportTicketsRoutes;
